<template>
    <div
        :class="{
        'has-error': hasErrors,
        'has-success': isSuccess
        }"
    >
        <div class="flex items-center">
            <slot name="label" :for-id="attributes.id">
                <label v-if="label" :for="attributes.id" :class="`${labelClass}`">
                    {{ label }}
                    <span v-if="info">
                    {{ info }}
                    </span>
                </label>
            </slot>

            <slot
                :attributes="attributes"
                :errors="activeErrors"
                :events="events"
                :first-error-message="firstErrorMessage"
                :has-errors="hasErrors"
                :validator="preferredValidator"
            />
        </div>

        <slot
            name="errors"
            :errors="activeErrors"
            :error-messages="activeErrorMessages"
            :has-errors="hasErrors"
            :first-error-message="firstErrorMessage"
        >
            <div :class="errorClasses" v-if="hasErrors">
                <span
                    v-if="showSingleError"
                    :data-validation-attr="firstError.validationKey"
                    class="text-xs"
                >
                    {{ firstErrorMessage }}
                </span>
                <template v-if="!showSingleError">
                    <span
                        v-for="error in activeErrors"
                        :key="error.validationKey"
                        :data-validation-attr="error.validationKey"
                        class="text-xs"
                    >
                        {{ getErrorMessage(error.validationKey, error.params) }}
                    </span>
                </template>
            </div>
        </slot>

    </div>
</template>

<script>
import { singleErrorExtractorMixin } from "vuelidate-error-extractor";
import { upperFirst, words, camelCase } from "lodash";

const snakeCase = function(value) {
    let result = "";

    words(value).forEach((word, index) => {
        if (/\d/.test(word)) {
            result = result + word;
        } else {
            result = result + (index ? "_" : "") + word.toLowerCase();
        }
    });

    return result;
};

export default {
    name: "TailwindInlineHelpblock",

    props: {
        errorClass: { type: String },
        labelClass: { type: String, default: "inline-block w-1/3 pr-16 leading-tight" },
        info: { type: String, default: "" },
        successOnEmpty: { type: Boolean, default: false }
    },

    mixins: [singleErrorExtractorMixin],

    computed: {
        attributes() {
            return {
                class: {
                    "ml-auto": true,
                },
                id: `input${upperFirst(camelCase(this.name))}` || undefined,
                name: snakeCase(this.name) || undefined,
            };
        },

        errorClasses() {
            let classes = 'flex flex-col mt-1'

            if (this.label) {
                classes += ' md:ml-auto md:w-2/3'
            }

            return classes
        },

        isSuccess() {
            if (this.successOnEmpty) {
                return this.isValid
            }

            return this.isValid && this.preferredValidator.$model !== "" && this.preferredValidator.$model !== null
        }
    }
};
</script>

<style lang="scss">
.has-error {
    @apply text-coral-darkest;

    textarea,
    input:not([type="checkbox"]):not([type="image"]) {
        @apply border-coral-darkest;
    }

    .multiselect {
        .multiselect__tags {
            @apply border-coral-darkest;
        }
        .multiselect__content-wrapper {
            @apply border-coral-darkest;
        }
    }
}

.has-success {
    textarea,
    input:not([type="checkbox"]):not([type="image"]) {
        @apply border-green-darkest;
    }

    .multiselect {
        .multiselect__tags {
            @apply border-green-darkest;
        }
        .multiselect__content-wrapper {
            @apply border-green-darkest;
        }
    }
}
</style>
